import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { GridComponent } from '@progress/kendo-angular-grid';
import { CommonService } from 'src/app/Service/Common.service';
import { ElementLinkService } from 'src/app/Service/element-link/element-link.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ProjectWorkflowStatusService } from 'src/app/Service/ProjectWorkflowStatus/ProjectWorkflowStatus.service';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { ModuleModel } from 'src/app/ViewModel/ModuleModel';
import { INumberInputModel, INumberViewModel } from 'src/app/ViewModel/ProjectWorkflowStatus';


export enum Modules {
  "Upload Document" = 1,
  "Schedule Document" = 2,
  "Workflow" = 3,
  "Communication" = 4,
  "Transmittal" = 5
}

const createFormGroup = (dataItem: { module_Name: any; module_Id: any; sl_No_Length: any; is_Active: any; }) => new FormGroup({
  'module_Name': new FormControl(dataItem.module_Name),
  'module_Id': new FormControl(dataItem.module_Id),
  'sl_No_Length': new FormControl(dataItem.sl_No_Length),
  'is_Active': new FormControl(dataItem.is_Active),
});

@Component({
  selector: 'app-number-configuration',
  templateUrl: './number-configuration.component.html',
  styleUrls: ['./number-configuration.component.css']
})
export class NumberConfigurationComponent implements OnInit {
  @ViewChild(GridComponent)
  private grid!: GridComponent;
  moduleList!: ReadonlyArray<ModuleModel>;

  numberConfigurationView!: INumberViewModel[];
  project_Id!: number;
  group_Id: number = 0;
  userId!: number;
  sl_No_Length!: number;
  enableFilter = false;
  public formGroup: FormGroup | any;
  editedRowIndex: number | undefined;
  isNewRow = false;
  isNew = false;
  input_Type: string = '';
  module_Id!: number;
  is_Active: boolean = true;
  selectedModuleId: any;
  selectedModuleClear = 'N';
  isCreate: boolean = true;
  isShowListPageIcon: boolean = false;


  constructor(private _ProjectWorkStatusService: ProjectWorkflowStatusService,
    public notificationService: NotificationService,
    public elementLinkService: ElementLinkService,
    public commonService: CommonService) { }

  ngOnInit() {
    this.project_Id = this.commonService.getProjectId();
    this.group_Id = this.commonService.getLoggedInUserGroupId();
    this.userId = this.commonService.getLoggedInUserId();
    this.getNumberConfigurationdetails();
  }

  getNumberConfigurationdetails() {
    this.input_Type = 'SELECT';
    this._ProjectWorkStatusService.getNumber(this.project_Id, this.group_Id, this.input_Type).subscribe((data: INumberViewModel[]) => {
      data.forEach(val => {
        val["module_Name"] = this.getModuleName(val.module_Id)
      });
      this.numberConfigurationView = data;
    });
  }

  getModuleName(moduleId: number) {
    switch (moduleId) {
      case 1:
        return "Upload Document";
      case 2:
        return "Schedule Document";
      case 3:
        return "Workflow";
      case 4:
        return "Communication";
      case 5:
        return "Transmittal"
      default:
        return '';
    }
  }

  changeModuleList(event: EIPAutoCompleteEventModel<ModuleModel>) {
    this.selectedModuleClear = 'N';
    if (this.isCreate) {
      if (event.value != '-2') {
        this.selectedModuleId = event.value;
      } else {
        this.selectedModuleId = null;
      }
    }
    if (event.value == '1') {
      this.isShowListPageIcon = true;
    } else {
      this.isShowListPageIcon = false;
    }
  }

  setFormValues(event: any) {
    this.formGroup.get('sl_No_Length')?.setValue(event.target.value);
    this.selectedModuleId = this.module_Id;
  }

  saveNC(dataItem: any) {
    if (!this.selectedModuleId) {
      this.notificationService.showToast('Select Module', 'Warning');
      return;
    }
    let _input: INumberInputModel = {
      project_Id: this.project_Id,
      group_Id: this.group_Id,
      userId: this.userId,
      module_Id: this.selectedModuleId,
      sl_No_Length: !!this.formGroup.get("sl_No_Length")?.value ? this.formGroup.get("sl_No_Length")?.value : dataItem.sl_No_Length,
      is_Active: dataItem.is_Active,
      input_Type: "INSERT"
    }
    this._ProjectWorkStatusService.postNumber(_input).subscribe((data) => {
      if (data.successCode == 200) {
        this.notificationService.showToast(data.successMessage, "Success");
        this.getNumberConfigurationdetails();
      }
      else {
        this.notificationService.showToast('Module Name Already Exist', 'Warning');
      }
    });
  }

  async callModule() {
    this.moduleList = await this.elementLinkService.getModuleList(this.group_Id).toPromise();
    this.moduleList = this.moduleList.filter(x => x.cedDescription != 'Workflow');
  }




  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }


  addHandler() {
    this.isNewRow = true;
    this.closeEditor();
    this.formGroup = createFormGroup({
      module_Name: '',
      module_Id: null,
      sl_No_Length: null,
      is_Active: true,
    });
    this.isNew = true;
    this.callModule();
    this.grid.addRow(this.formGroup);
  }

  editRowData(dataItem: any) {
    if (this.editedRowIndex && this.editedRowIndex >= 0) {
      dataItem.sender.closeRow(this.editedRowIndex);
    }
    this.editedRowIndex = dataItem.rowIndex;
    this.formGroup = createFormGroup(dataItem);
    this.isNewRow = false;
    dataItem.sender.editRow(dataItem.rowIndex);
  }

  UpdateRowData({ sender, rowIndex, dataItem }) {
    let newNumberlist: INumberViewModel = this.formGroup.value;
    if (newNumberlist.sl_No_Length <= 0 || newNumberlist.sl_No_Length >= 10) {
      this.notificationService.showToast('Serial No Length can be between 1 and 9 only!!!', 'Warning');
      return;
    }
    if (this.isNewRow == true) {
      this.saveNC(dataItem);
    }
    else {
      this.updateNC(dataItem);
    }
    this.isNewRow = false;
    dataItem.sender.closeRow(dataItem.rowIndex);
  }

  updataSlNo(event: any) {
    this.formGroup.get("sl_No_Length")?.setValue(event.target.value)
  }

  updateNC(dataItem: any) {
    let _input: INumberInputModel = {
      project_Id: this.project_Id,
      group_Id: this.group_Id,
      userId: this.userId,
      module_Id: dataItem.module_Id,
      //is_Active: this.formGroup.get('is_Active')?.value,
      is_Active: dataItem.is_Active,
      sl_No_Length: !!this.formGroup.get("sl_No_Length")?.value ? this.formGroup.get("sl_No_Length")?.value : dataItem.dataItem.sl_No_Length,
      input_Type: "UPDATE"
    }
    this._ProjectWorkStatusService.postNumber(_input).subscribe((data) => {
      if (data.successCode == 200) {
        this.notificationService.showToast(data.successMessage, "Success");
        this.getNumberConfigurationdetails();
      }
      else {
        this.notificationService.showToast(data.successMessage, "Error");
      }
    });

  }

  changeActiveStatus(event: MatCheckboxChange) {
    this.formGroup.get('is_Active')?.setValue(event.checked);
  }

  public cellClickHandler(dataItem: any): void {
    if (dataItem.isEdited) {
      return;
    }
    this.formGroup = createFormGroup(dataItem);
    this.editedRowIndex = dataItem.rowIndex;
    this.grid.editRow(dataItem.rowIndex, this.formGroup);

  }

  cancelRowData(dataItem: any) {
    this.isNewRow = false;
    dataItem.sender.closeRow(dataItem.rowIndex);
  }

  public cancelHandler(): void {
    this.closeEditor();
  }

  private closeEditor(): void {
    if (this.editedRowIndex)
      this.grid.closeRow(this.editedRowIndex);
    this.isNew = false;
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }
}
